module.exports = __webpack_public_path__ + "static/media/ePharmacie_process_flow_Slide2_French.dd192dc7.png";